import UnForm from "../../../../Components/Form";

interface IGeneralInformationTwilio {
    name: string;
    onNameChange: (name: string) => void;
}

export default function GeneralInformationTwilio(
    props: IGeneralInformationTwilio
) {
    const { name, onNameChange } = props;

    return (
        <div className="form-group">
            <label>Nome do Template</label>
            <UnForm.Input
                name="name"
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => onNameChange(e.target.value)}
                required
            />
        </div>
    );
}
